export default __webpack_public_path__ + "files/NCSA_logo-4fd245f26f8f1ad6909e74212259512f.png";